<template>
	<div>
		<div class="row mt-2 mb-3">
			<div class="col-12 col-md-6">
				<label class="akkurate-dark small" for="loan-re-date"
					>Start Dates</label
				>
				<b-form-group id="loan-re-date" label-for="loan-re-date">
					<b-form-input
						class="mt-2 field-container fields"
						type="date"
						v-model="form.start_date"></b-form-input>
				</b-form-group>
			</div>
			<div class="col-12 col-md-6">
				<label class="akkurate-dark small" for="loan-re-date"
					>End Date</label
				>
				<b-form-group id="loan-re-date" label-for="loan-re-date">
					<b-form-input
						class="mt-2 field-container fields"
						type="date"
						v-model="form.end_date"></b-form-input>
				</b-form-group>
			</div>

			<div class="col-12 col-md-6">
				<label class="akkurate-dark small" for="branch">Branch</label>
				<multiselect
					class="mt-2 field-container"
					v-model="form.branch"
					:options="branch_option"
					track-by="name"
					@input="onBranchChange"
					:multiple="true"
					placeholder="Select branch"
					selectLabel=""
					deselectLabel=""
					label="name">
				</multiselect>
			</div>
			<div class="col-12 col-md-6">
				<label class="akkurate-dark small" for="scheme">Scheme </label>
				<multiselect
					class="mt-2 field-container"
					v-model="form.schemes"
					:options="schemes_option"
					@input="onSchemesChange"
					:multiple="true"
					selectLabel=""
					deselectLabel=""
					track-by="name"
					placeholder="Select scheme"
					label="name">
				</multiselect>
			</div>
			<div class="col-12 col-md-6">
				<label class="akkurate-dark small" for="scheme"
					>Loan Stages
				</label>
				<multiselect
					class="mt-2 field-container"
					v-model="form.loan_stages"
					:options="loan_stages_options"
					:multiple="true"
					selectLabel=""
					deselectLabel=""
					track-by="id"
					placeholder="Select Loan Stage"
					label="name">
				</multiselect>
			</div>

			<div class="col-12 col-md-6">
				<label class="akkurate-dark small" for="branch">Terms</label>
				<multiselect
					class="mt-2 field-container"
					v-model="form.term"
					:options="terms_option"
					placeholder="Select one"
					selectLabel=""
					deselectLabel="">
				</multiselect>
			</div>
		</div>
	</div>
</template>

<script>
	import Multiselect from "vue-multiselect";
	export default {
		props: [
			"form",
			"filterTable",
			"branch_option",
			"schemes_option",
			"loan_stages_options",
		],
		components: {
			Multiselect,
		},
		data() {
			return {
				branch_arr: [],
				schemes_arr: [],
				terms_option: ["YTD", "Periodic"],
				// more_details: false,
			};
		},
		methods: {
			onBranchChange() {
				this.branch_arr = [];
				this.form.branch.map((index) => {
					this.branch_arr.push(index.id);
				});
				this.$emit("branch_arr", this.branch_arr);
			},
			onSchemesChange() {
				this.schemes_arr = [];
				this.form.schemes.map((index) => {
					this.schemes_arr.push(index.id);
				});
				this.$emit("schemes_arr", this.schemes_arr);
			},
			// show_more() {
			//     this.more_details = !this.more_details
			// }
		},
	};
</script>
